import React from 'react';
import './Blogs.css';
import blog1 from '../../images/Blog/blog.jpg';
import blog2 from '../../images/Blog/blog1.jpg';


const Blogs = () => {
    return (
        <div>
            <h1 className="mt-5 mb-2 text-center">Latest Blog</h1>
            <p className="paragraph">Lorem ipsum dolor sit amet, conseetuer adipiscing elit. Aenan comdo igula eget. Aenean massa cum sociis Theme natoque.</p>
            <div className="blog-container">
                <div className="blog">
                    <img className="rounded-3"  src={blog2} alt="" />
                    <div className="pt-3 blog-btn">
                        <div><button className="Btn">29 DEC, 2021</button></div>
                        <div><p>By Admin</p></div>
                        <div><p>3 Comments</p></div>
                    </div>
                    <h2 className="pt-4">Tips To Reduce Your Travel Costs</h2>
                    <p>There are many variations of passages of lorem ipsum available but the majority have suffered alteration...</p>
                </div>
                <div className="blog">
                    <img className="rounded-3" src={blog1} alt="" />
                    <div className="pt-3 blog-btn">
                        <div><button className="Btn">29 DEC, 2021</button></div>
                        <div><p>By Admin</p></div>
                        <div><p>3 Comments</p></div>
                    </div>
                    <h2 className="pt-4">Your Card Processing Forms</h2>
                    <p>There are many variations of passages of lorem ipsum available but the majority have suffered alteration...</p>
                </div>
            </div>
            <br /><br />
        </div>
    );
};

export default Blogs;